import { render } from "./ChatMsgContainer.vue?vue&type=template&id=fd5e066c&scoped=true"
import script from "./ChatMsgContainer.vue?vue&type=script&lang=js"
export * from "./ChatMsgContainer.vue?vue&type=script&lang=js"

import "./ChatMsgContainer.vue?vue&type=style&index=0&id=fd5e066c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd5e066c"]])

export default __exports__